import DefaultResidenceFlow from './DefaultResidence';

export default DefaultResidenceFlow;